import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/APIKey.css'
//Material UI component
import Button from '@material-ui/core/Button'
import FileCopy from '@material-ui/icons/FileCopy'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import green from '@material-ui/core/colors/green'
//store
import profile from '../store/profile'
import prompt from '../store/prompt'
import {observer} from 'mobx-react'

@observer
class APIKey extends React.Component {
  constructor(props){
    super(props);
    this.state={
      open:false
    }
    this.regenerateKey = this.regenerateKey.bind(this);
  }
  regenerateKey(){
    var key = document.getElementById('APIKey__key');
    key.select();
    document.execCommand('copy');
    prompt.message('Copied');
  }
  render () {
    return(
      <div className='APIKey'>
        <textarea id='APIKey__key' className='APIKey__key' readOnly='true' value={profile.apiKey}></textarea>
        <div onClick={this.regenerateKey} className='APIKey__regenerateBtn'>
          <Button
            variant = 'contained'
            color = 'secondary'
            size = 'large'
            >
            <FileCopy /><span style={{marginLeft:5}}>Copy</span>
          </Button>
        </div>
      </div>
    )
  }
}

export default APIKey;



// WEBPACK FOOTER //
// ./src/components/APIKey.js